import React, { Component } from 'react'
import axios from 'axios'
import { API_URL } from '../constants'
import styled from 'styled-components'
import { uniqBy, isEmpty, get, toUpper, capitalize, indexOf, flatMap, size, lowerCase, intersection } from 'lodash'
import qs from 'qs'
import {
  Header,
  Card,
  FlexWrapper,
  CustomSlider,
  ProductView,
  TopSection,
  PageWrapper,
  PageLoader,
  WarningCard,
  SecondaryHeader
} from '../components'
import Cookies from 'js-cookie'
import { gsCalculator, priceRangeCalculator, upperlower, isAdmin, filterHiddenData } from '../utlis/functions'

const SectionWrap = styled.div`
  & > div {
    & > div {
      padding: 0;
    }
    & > div:nth-child(2) {
      & > div > div > div:first-child {
        margin-left: 0;
      }
    }
  }
  & > div:nth-child(even) {
    background: #f2e9d4;
  }
`
const SectionWrapper = styled.div`
  background: ${props => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  padding: ${props => (props.padding ? props.padding : '30px 16px')};
`

const bbcWarning = [
  {
    title: 'Perdue is recalling chicken nuggets',
    newspaper: 'USA Today - 29 January 2019',
    link:
      'https://www.usatoday.com/story/money/2019/01/29/perdue-recalling-chicken-nuggets-undeclared-allergen/2712679002/'
  },
  {
    title: 'Tonnes of chicken nuggets recalled in US',
    newspaper: 'BBC News - 30 January 2019',
    link: 'https://www.bbc.com/news/business-47062139'
  }
]

class Category extends Component {
  state = { loader: false, data: [], favroitesData: [], selectedStores: [] }

  async componentDidMount() {
    this.setState({ loader: true })
    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    await this.fetchWarningConflicts()
    await this.getFavouriteData()
    await this.fetchData()
    await this.setState({ loader: false })
  }

  fetchData = async () => {
    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            { productCategory: this.props.match.params.tab },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          productCategory: this.props.match.params.tab
        }
    const query = {
      filter: {
        where: selectedStoresFilter,
        limit: 1000,
        order: ['totalGs DESC'],
        include: ['productCost', 'users']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      const uniqData = uniqBy(data, 'productType')
      const newData = uniqData
        .map(item => item.productType)
        .map((item, idx) => {
          return { type: item, data: uniqBy(data.filter(prod => prod.productType === item), 'productCode') }
        })
      this.setState({ data: newData })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }
  fetchWarningConflicts = async () => {
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }

  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      this.setState({ favouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      await this.getFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      await this.getFavouriteData()
    }
  }
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }
  render() {
    const { match } = this.props
    const { favouriteData, data, loader, userData } = this.state
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    return (
      <React.Fragment>
        <Header
          title={match.params.tab}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <SecondaryHeader clicked={this.onStoreChange} padding="70px 16px 0" />
        {loader ? (
          <PageLoader />
        ) : isEmpty(data) ? (
          <PageWrapper viewPadding="17% 0 0" height="auto" modifyPadding="14px 0 0">
            <SectionWrap>
              <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
                {console.log('empty')}
                <FlexWrapper alignItems="center">
                  <h3>No Products found for this category</h3>
                </FlexWrapper>
              </Card>
            </SectionWrap>
          </PageWrapper>
        ) : (
          <PageWrapper viewPadding="17% 0 0" height="auto" modifyPadding="0 0 0">
            <SectionWrap>
              {data.map((item, index) => {
                return (
                  <SectionWrapper key={index}>
                    <TopSection
                      title={upperlower(item.type, 'titlecase')}
                      to={`/category/${match.params.tab}/${item.type}`}
                      noSubtitle
                      margin="0 0 10px 0"
                    />
                    {isEmpty(filterHiddenData(item.data)) ? (
                      <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
                        <FlexWrapper alignItems="center">
                          <h3>{loader ? 'Loading..' : 'No products found'}</h3>
                        </FlexWrapper>
                      </Card>
                    ) : (
                      <React.Fragment>
                        <FlexWrapper>
                          <CustomSlider
                            itemWidth={154}
                            numberOfItems={filterHiddenData(item.data).slice(0, 30).length}
                            margin="4px 5px">
                            {filterHiddenData(item.data)
                              .slice(0, 30)
                              .map(item => {
                                const priceRange = get(item, 'productCost', []).map(range =>
                                  range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                                )

                                const allergyConflicts = get(item, 'allergyConflicts', '')
                                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                                  .toLowerCase()
                                  .split(',')
                                  .map(item => item.trim())
                                const dietConflicts = get(item, 'dietConflicts', '')
                                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                                  .toLowerCase()
                                  .split(',')
                                  .map(item => item.trim())
                                return (
                                  <ProductView
                                    conflict={
                                      !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                                      !isEmpty(intersection(userDiets, dietConflicts))
                                    }
                                    favValue={item.users ? item.users.length : 0}
                                    key={item.productCode}
                                    imageUrl={item.productImage}
                                    quantity={
                                      size(get(item, 'productQuantity', '')) < 15
                                        ? toUpper(get(item, 'productQuantity', ''))
                                        : ''
                                    }
                                    productName={capitalize(item.productName)}
                                    priceRange={priceRangeCalculator(priceRange)}
                                    progressValue={Math.round(item.totalGs, 0)}
                                    isFavorite
                                    isHidden={isAdmin() && item.isHidden ? true : false}
                                    favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                                    onFavorite={() => this.changeFavouriteData(item.productCode)}
                                    onClick={() =>
                                      this.props.history.push({
                                        pathname: `/products/${item.productCode}/green-score`
                                      })
                                    }
                                    imageWidth="100px"
                                    imageHeight="115px"
                                  />
                                )
                              })}
                          </CustomSlider>
                          {(this.props.match.params.tab === 'Meat' || this.props.match.params.tab === 'Frozen') &&
                            index === 0 && (
                              <CustomSlider itemWidth={300} numberOfItems={bbcWarning.length}>
                                {bbcWarning.map(item => (
                                  <WarningCard
                                    forWarning
                                    text={item.title}
                                    newspaper={item.newspaper}
                                    onClickCard={() =>
                                      this.props.history.push({
                                        pathname: '/gcnow-stories/warning',
                                        state: {
                                          link: item.link
                                        }
                                      })
                                    }
                                  />
                                ))}
                              </CustomSlider>
                            )}
                        </FlexWrapper>
                      </React.Fragment>
                    )}
                  </SectionWrapper>
                )
              })}
            </SectionWrap>
          </PageWrapper>
        )}
      </React.Fragment>
    )
  }
}

export default Category



// WEBPACK FOOTER //
// ./src/pages/Category.js